/// <reference path="../../typings/tsd.d.ts" /> 
module Elp.Api {
   export class Helper {
       public static callFunction(id: string, processId: string, formId: string, formDataId) {
           const processService: Services.ProcessService = angular.element(document.body).injector().get('processService');

           const processDto = processService.getCachedProcess(processId);
           let customFunction;

           for (let stepId in processDto.customStepFunctions) {
               processDto.customStepFunctions[stepId].forEach(func => {
                   if (func.id === id) {
                       customFunction = func;
                   }
               });
           }

           if (customFunction) {
               let args = ['processId', 'formId', 'formDataId',customFunction.javascript];
               let myFunc = Function.apply(null, args);

               myFunc(processId, formId,formDataId);
           }

       }
   } 
}